<!-- 富文本 -->
<template>
    <div style="border: 1px solid #ccc;">
      <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
        :mode="mode"
      />
      <Editor
        style="height: 400px; overflow-y: hidden;"
        v-model="editorValue"
        :defaultConfig="editorConfig"
        :mode="mode"
        @onCreated="createEditor"
      />
    </div>
  </template>

  <script>
  import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
  import { uploadURL } from "@/config.js";
  export default {
    name: "wangeditor",
    components: {
      Editor,
      Toolbar
    },
    props: {
      value: {
        type: String,
        default: ""
      }
    },

    data() {
      return {
        editor: null,
        toolbarConfig: {},
        editorConfig: {
          placeholder: "请输入内容...",
          MENU_CONF: { uploadImage: null }
        },
        mode: "default"
      };
    },

    computed: {
      editorValue: {
        get: function() {
          return this.value;
        },
        set: function(val) {
          this.$emit("input", val);
        }
      }
    },
    created() {
      let that = this;
      this.editorConfig.MENU_CONF["uploadImage"] = {
        // 自定义上传
        async customUpload(file, insertFn) {
          let result = await that.uploadFile(file);
          console.log(result);
          insertFn(result, "", "");
        }
      };
      this.editorConfig.MENU_CONF["uploadVideo"] = {
        // 自定义上传
        async customUpload(file, insertFn) {
          let result = await that.uploadFile(file);
          console.log(result);
          insertFn(result);
        }
      };
    },
    mounted() {
      // let that = this;
      // this.createEditor({
      //   config: this.editorConfig
      // });
    },
    beforeDestroy() {
      const editor = this.editor;
      if (editor == null) return;
      editor.destroy(); // 组件销毁时，及时销毁编辑器
    },

    methods: {
      async uploadFile(file) {
        console.log(file);
        return new Promise(resolve => {
          let params = new FormData();
          params.append("file", file);
          params.append("aliases", file.name);
          this.$api
            .formDataPost(uploadURL + "/api/file/upload", params)
            .then(res => {
              console.log(res);
              let imgUrl =
                uploadURL +
                "/api/file/downloadFile?fileHashOrWholeFileId=" +
                res.retBody.fileId;
              resolve(imgUrl);
            });
        });
      },
      createEditor(editor) {
        if (!editor) {
          return;
        }
        this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      },
      disable() {
        this.editor && this.editor.disable();
      }
    }
  };
  </script>
  <style lang="scss" scoped>
  </style>



// WEBPACK FOOTER //
// src/components/editor/index.vue